import * as ShippingMutationType from '../shipping/mutationTypes';

export default {
  shipping: ShippingMutationType,
};
